import ReactDOM from "react-dom/client";
import html2pdf from "html2pdf.js";

import { ReceiptTemplate } from "pages/Transactions/TransactionDetails/Receipt";

export const generateReceipt = ({ data, totalAmount, isCredit }) => {
  if (!data) return;

  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(
    <ReceiptTemplate data={data} totalAmount={totalAmount} isCredit={isCredit} />
  );

  const options = {
    margin: 0,
    filename: "transaction-receipt.pdf",
    html2canvas: { scale: 2 },
    jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
  };

  html2pdf()
    .from(container)
    .set(options)
    .save()
    .then(() => {
      root.unmount();
      document.body.removeChild(container);
    });
};
